import React, { Component } from "react";
import Flippy, { FrontSide, BackSide } from 'react-flippy';
import solvente from '../../assets/images/solvente.png';
import formulario from '../../assets/images/formulario.png';
import documentos from '../../assets/images/documentos.png';
import email from '../../assets/images/email.png';
import './Cards.css';
import { MDBRow, MDBCol } from "mdbreact";

class Cards extends Component {
    render() {
        return (
            <React.Fragment>
                <div className="container-fluid">
                    <div className="spacer-50"></div>

                    <MDBRow className="row mb-4">
                        <MDBCol className="col lih-1">
                            <h1 className="title-recomendaciones wow animated zoomInDown fz-r">
                                PASOS DE RECEPCIÓN 
                            </h1>
                            <p className="title-section font-weight-bold wow animated zoomInDown delay-1"> DE DOCUMENTOS EN LÍNEA</p>
                        </MDBCol>
                    </MDBRow>

                    <MDBRow className="wow fadeInRight justify-content-center">
                        <MDBCol className="col-12 col-md-6 col-lg-3 mb-4 mt-4">
                            <Flippy
                                flipOnHover={true}
                                flipDirection="vertical"
                                flipOnClick={true}
                                ref={(r) => this.flippy = r}
                                className="flip"
                                style={{ height: '250px', maxWidth: '300px', margin: '0 auto' }}
                            >
                                <FrontSide className="cuadro1">
                                    <img src={solvente} className="iconoCard" alt="Debes estar solvente" />
                                    <div className="futuraBold tituloCard text-uppercase">
                                        Debes estar solvente
                                    </div>
                                </FrontSide>
                                <BackSide
                                    className="backSide">
                                    <div className="textoBackSide contenedorCenterVertical">
                                        Debes haber cancelado el costo de tus aranceles generados en tu trámite.
                                        </div>
                                </BackSide>
                            </Flippy>
                        </MDBCol>
                        <MDBCol className="col-12 col-md-6 col-lg-3 mb-4 mt-4">
                            <Flippy
                                flipOnHover={true}
                                flipDirection="vertical"
                                flipOnClick={true}
                                ref={(r) => this.flippy = r}
                                style={{ height: '250px', maxWidth: '300px', margin: '0 auto' }}
                            >
                                <FrontSide className="cuadro2">
                                    <img src={formulario} className="iconoCard" alt="Completar el formulario" />
                                    <div className="futuraBold tituloCard text-uppercase">
                                        Completar el formulario
                                    </div>
                                </FrontSide>
                                <BackSide
                                    className="backSide">
                                    <div className="textoBackSide contenedorCenterVertical">
                                        Inicia el trámite completando el Formulario de Documentación en Línea.
                                        </div>
                                </BackSide>
                            </Flippy>
                        </MDBCol>
                        <MDBCol className="col-12 col-md-6 col-lg-3 mb-4 mt-4">
                            <Flippy
                                flipOnHover={true}
                                flipDirection="vertical"
                                flipOnClick={true}
                                ref={(r) => this.flippy = r}
                                style={{ height: '250px', maxWidth: '300px', margin: '0 auto' }}
                            >
                                <FrontSide className="cuadro1">
                                    <img src={documentos} className="iconoCard" alt="Alojar tus documentos" />
                                    <div className="futuraBold tituloCard text-uppercase">
                                        Alojar tus documentos
                                    </div>
                                </FrontSide>
                                <BackSide
                                    className="backSide">
                                    <div className="textoBackSide contenedorCenterVertical">
                                        Adjunta tus documentos siguiendo las recomendaciones brindadas, si no cuentas con alguno debes firmar de manera digital tu carta compromiso.
                                        </div>
                                </BackSide>
                            </Flippy>
                        </MDBCol>
                        <MDBCol className="col-12 col-md-6 col-lg-3 mb-4 mt-4">
                            <Flippy
                                flipOnHover={true}
                                flipDirection="vertical"
                                flipOnClick={true}
                                ref={(r) => this.flippy = r}
                                style={{ height: '250px', maxWidth: '300px', margin: '0 auto' }}
                            >
                                <FrontSide className="cuadro2">
                                    <img src={email} className="iconoCard" alt="Validacion de documentos" />
                                    <div className="futuraBold tituloCard text-uppercase">
                                        Validación de documentos
                                    </div>
                                </FrontSide> 
                                <BackSide className="backSide">
                                    <div className="textoBackSide contenedorCenterVertical">
                                        Se validará si tus documentos cumplen con los criterios de aceptación; en caso que alguno sea rechazado, recibirás un correo electrónico con las observaciones.
                                    </div>
                                </BackSide>
                            </Flippy>
                        </MDBCol>
                    </MDBRow>
                </div>
            </React.Fragment>
        );
    }
}
export default Cards;